export default "__VITE_PUBLIC_ASSET__460b96e5__"